import { Jetons } from './jetons';
import { MailingListHistory } from './mailingListHistory';
import { User } from './user';
export class UserReport {
  public idUser: string;
  public firstName: string;
  public lastName: string;
  public phone: string;
  public email: string;
  public connectionToday: number;
  public connectionTotal: number;
  public connectionOneWeek: number;
  public researchToday: number;
  public researchOneWeek: number;
  public researchTotal: number;
  public reportToday: number;
  public reportTotal: number;
  public reportOneWeek: number;
  public renewPackageTotal: number;
  public tokenSpendTotal: number;
  public tokenSpendOneWeek: number;
  public totalToken: number;
  public numberOfToken: number;
  public corpoTokenUsed: number;
  public corpoTokenAllocated: number;
  public currentCorpoToken: number;
  public tokenLost: number;
  public spendMoney: number;
  public renewPackageDate: Date;
  public lastAccess: Date;
  public creation: Date;
  public active: number;
  public accessOldMap: boolean;
  public other: string;
  public overrideReportActive: string;
  public typeName: string;
  public subTypeName: string;
  public activeName: string;
  public typePlan: string;
  public jetons: Jetons[];
  public role: string;
  public mailingList: Date;
  public mailingListDate: Date;
  public mailingListHistory?: MailingListHistory[];

  public static fromJson(json: object): UserReport {
    const userReport = new UserReport();
    Object.assign(userReport, json);

    userReport.renewPackageDate = new Date(json['renewPackageDate']);
    userReport.lastAccess = new Date(json['lastAccess']);
    userReport.creation = new Date(json['creation']);
    userReport.mailingListDate = new Date(json['mailingListDate']);

    userReport.mailingListHistory = json['mailingListHistory']?.map(MailingListHistory.fromJson) || [];

    return userReport;
  }


  public getUser(): User {
    const user: User = new User();
    user.id = this.idUser;
    user.email = this.email;
    user.role = this.role;
    user.active = this.active;
    user.accessOldMap = this.accessOldMap;
    return user;
  }
}
